/* ============
 * ProductDeposits Module Mutations
 * ============
 *
 * todo: add documentation here!
 */

import {
  FETCH_ALL_PRODUCT_DEPOSITS,
  ADD_NULL_DEPOSIT_LIST,
} from './../../mutation-types';

export default {
  [FETCH_ALL_PRODUCT_DEPOSITS](state, { productDeposits }) {
    state.all = productDeposits;
  },

  [ADD_NULL_DEPOSIT_LIST](state) {
    state.all.splice(0, 0, { id: '', name: '' });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productDeposit/mutations.js